// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__19NOR","col":"Table_col__8OKeO","fulfillmentStatus":"Table_fulfillmentStatus__LD5z3","emailCol":"Table_emailCol__2l3ca"};